import React, { useContext, useEffect } from 'react'
import { Switch, Router, Route, withRouter } from 'react-router-dom'
import { PageContext } from './context/PageContext'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import Home from './scenes/Home'
import Zone from './scenes/Zone'

 const { REACT_APP_PUBLIC_URL } = process.env;

const Routes = withRouter(({ location }) => {
  const { page, updatePage } = useContext(PageContext)
  // const body = document.querySelector('body')

  useEffect(() => {
      updatePage({ pageSlug: location.pathname });

    },
    [location]
  ) 

  return ( 
   /*
    <TransitionGroup component="div" className="App">
      <CSSTransition   
        key={location && location.pathname}
        timeout={0}
        classNames={`pageTransition`}
        mountOnEnter={true}
        unmountOnExit={true}
      >  
    */   
        <Switch>

            <Route exact path={`/`} component={Home} />
            <Route exact path={`/zone/:region`} component={Zone} />
        </Switch>
        /*
      </CSSTransition> 
    </TransitionGroup> 
    */
  )
})
export default Routes;
